module.exports = __webpack_public_path__ + "static/media/mobile-service-uiux.249e4d71.jpg";